var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c(
      "td",
      {
        staticClass: "kpi-benchmarks-table__sub-section",
        attrs: { colspan: "9" }
      },
      [_vm._v(_vm._s(_vm.name))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }